import React, { useState, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import ExpertiseDropDown from "./DropDowns/ExpertiseDropDown";
import LevelsDropDown from "./DropDowns/LevelsDropDown";
import HowHelpDropDown from "./DropDowns/HowHelpDropDown";

export default function Experience({ initial = {}, uploadMedia, saveProfile }) {
  const [form, setForm] = useState({
    linkedinUrl: initial.linkedinUrl || "",
    portfolioUrl: initial.portfolioUrl || "",
    expertise: initial.expertise || [],
    howHelp: initial.howHelp || [],
    levels: initial.levels || [],
    resume: initial.resume || "",
  });
  const [files, setFiles] = useState([]);
  const [drag, setDrag] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const text = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));
  const setArr = (k) => (v) => setForm(p => ({ ...p, [k]: v }));

  const add = (arr) => setFiles(p => [...p, ...arr]);
  const drop = e => { e.preventDefault(); setDrag(false); add(Array.from(e.dataTransfer.files)); };

  const submit = async e => {
    e.preventDefault();
    let resumeUrl = form.resume;
    const pdf = files.find(f => f.type === "application/pdf");
    if (pdf) resumeUrl = await uploadMedia([pdf]);
    await saveProfile({
      experience: { ...form, resume: resumeUrl, files: [] },
    });
    setFiles([]);
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <h3>Professional Experience</h3>

        <div className={Classes.infoConMiddle}>
          {/* expertise + level */}
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Areas of Expertise</h5>
              <ExpertiseDropDown selected={form.expertise} onChange={setArr("expertise")} />
            </div>
          </div>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>How Do You Want to Help Mentees</h5>
              <HowHelpDropDown selected={form.howHelp} onChange={setArr("howHelp")} />
            </div>
          </div>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Level of Experience</h5>
              <LevelsDropDown selected={form.levels} onChange={setArr("levels")} />
            </div>
          </div>

          {/* URLs */}
          {[
            ["linkedinUrl", "LinkedIn Profile URL", "https://linkedin.com/in/you"],
            ["portfolioUrl", "Portfolio URL", "https://portfolio.example.com"],
          ].map(([k, l, ph]) => (
            <div key={k} className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <div className="flexAlign10">
                  <h5 className={Classes.label}>
                    {l}
                  </h5>
                  <div className="optionalText"><h5>Optional</h5></div>
                </div>
                <input
                  name={k}
                  className={Classes.inputField}
                  placeholder={ph}
                  value={form[k]}
                  onChange={text}
                />
              </div>
            </div>
          ))}

          {/* resume */}
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>Resume</h5>
                <div className="optionalText"><h5>Optional</h5></div>
              </div>
              <div
                className={`${Classes.fileUpload} ${drag ? Classes.dragActive : ""}`}
                onDragOver={e => { e.preventDefault(); setDrag(true); }}
                onDragLeave={() => setDrag(false)}
                onDrop={drop}
                onClick={() => inputRef.current.click()}
              >
                <input ref={inputRef} type="file" className={Classes.fileInput} multiple
                  onChange={e => add(Array.from(e.target.files))} />
                <h5><span className={Classes.browseText}>Browse</span> or drag & drop</h5>
              </div>
              {files.length > 0 && (
                <ul className={Classes.fileList}>{files.map((f, i) => <li key={i}><h5>{f.name}</h5></li>)}</ul>
              )}
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
